import {css} from '../theme/css'
import {theme} from '../theme/theme'
import {ClassNameMap, makeStyles} from '../theme/UNSTABLE_makeStyles'
import {ClasslessSvgIconProps} from './SvgIcon'

const root = css`
  user-select: none;
  width: 1em;
  height: 1em;
  display: inline-block;
  fill: currentColor;
  flex-shrink: 0;
  font-size: ${theme.typography.pxToRem(24)};
  transition: ${theme.transitions.create('fill', {
    duration: theme.transitions.duration.shorter,
  })};
  vertical-align: middle;
`
const colorClasses: ClassNameMap<`color_${ClasslessSvgIconProps['color']}`> = {
  color_inherit: undefined,
  color_primary: css`
    color: ${theme.palette.primary.main};
  `,
  color_secondary: css`
    color: ${theme.palette.secondary.main};
  `,
  color_action: css`
    color: ${theme.palette.action.active};
  `,
  color_error: css`
    color: ${theme.palette.error.main};
  `,
  color_disabled: css`
    color: ${theme.palette.action.disabled};
  `,
}
const fontClasses: ClassNameMap<`font_size_${ClasslessSvgIconProps['fontSize']}`> = {
  font_size_default: undefined,
  font_size_inherit: css`
    font-size: inherit;
  `,
  font_size_small: css`
    font-size: ${theme.typography.pxToRem(20)};
  `,
  font_size_large: css`
    font-size: ${theme.typography.pxToRem(35)};
  `,
}
export const classes = Object.assign(
  {
    root,
  },
  colorClasses,
  fontClasses,
)

export type ClassKey = keyof typeof classes
export type ClassMap = ClassNameMap<ClassKey>

export const useClasses = makeStyles(classes)
